import { Badge, Card } from "@ruter-as/web-components-and-tools";
import "./HousingCooperativeInfo.scss";

const HousingCooperativeInfo: React.FC = () => {
	return (
		<Card skin="alternate" className="housing-info-component">
			<div className="badge-wrapper">
				<Badge>Nyhet</Badge>
			</div>
			<Card.Content className="content">
				<Card.Title>Beboere i Usbl borettslag</Card.Title>
				<Card.Paragraph>
					Som et prøveprosjekt tilbyr nå Ruter og Usbl lavere pris på
					månedsbillett og leiebil. Her kan du sette deg inn i detaljene.
				</Card.Paragraph>
				<h3>Lavere pris på månedsbillett</h3>
				<Card.Paragraph>
					Med månedsbillett for borettslag sparer du minst 130 kr hver måned
					sammenlignet med 30-dagers billetten.
				</Card.Paragraph>
				<h3>Månedlig rabatt på leiebil</h3>
				<Card.Paragraph>
					For 49 kr i måneden får du 200 kr i rabattkode (rollover opptil 600
					kr). Når du henter ut rabatten hos Getaround, Hyre eller
					Bilkollektivet, starter opptjeningen av ny rabatt.
				</Card.Paragraph>
				{/* <h3>Fast rabatt på leie av elsykkel</h3>
				<Card.Paragraph>
					Få 500 kr i månedlig rabatt på{" "}
					<span style={{ textDecoration: "underline" }}>
						testvinnende elsykkel
					</span>{" "}
					fra Joule (så langt lageret rekker). Tjenesten har ingen bindingstid
					og inkluderer blant annet service, forsikring og mulighet for
					leie-til-eie.
				</Card.Paragraph> */}
			</Card.Content>
		</Card>
	);
};

export default HousingCooperativeInfo;
